var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPassSymb = function SvgPassSymb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18.6,
    height: 22.6,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "25.634%",
    y1: "-54.318%",
    x2: "75.945%",
    y2: "147.336%",
    id: "passSymb_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FBC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BA88",
    offset: "100%"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.3 0c1.635 0 3.116.649 4.187 1.696A5.721 5.721 0 0 1 15.225 5.8v1.912a3.7 3.7 0 0 1 2.295 1.041A3.556 3.556 0 0 1 18.6 11.3V19a3.556 3.556 0 0 1-1.08 2.547 3.706 3.706 0 0 1-2.595 1.053H3.675a3.706 3.706 0 0 1-2.595-1.053A3.556 3.556 0 0 1 0 19v-7.7a3.556 3.556 0 0 1 1.08-2.547 3.7 3.7 0 0 1 2.295-1.04V5.8c0-1.602.664-3.053 1.738-4.104A5.971 5.971 0 0 1 9.3 0Zm0 1.7c1.16 0 2.212.46 2.972 1.203A4.039 4.039 0 0 1 13.5 5.8v1.9H5.1V5.8c0-1.131.47-2.155 1.228-2.897A4.238 4.238 0 0 1 9.3 1.7Zm5.625 7.7c.539 0 1.027.214 1.38.56.351.343.57.817.57 1.34V19c0 .523-.219.997-.57 1.34a1.972 1.972 0 0 1-1.38.56H3.675c-.539 0-1.027-.214-1.38-.56a1.873 1.873 0 0 1-.57-1.34v-7.7c0-.523.219-.997.57-1.34a1.972 1.972 0 0 1 1.38-.56h11.25ZM9.3 12.15c-1.017 0-1.84.806-1.84 1.8 0 .783.513 1.442 1.226 1.69v1.91c0 .332.275.6.614.6.34 0 .614-.269.614-.6v-1.91c.713-.25 1.226-.908 1.227-1.69 0-.994-.824-1.8-1.841-1.8Zm.016 2.4a.6.6 0 1 1 0-1.2.6.6 0 0 1 0 1.2Z",
    fill: "url(#passSymb_svg__a)",
    fillRule: "evenodd"
  })));
};
export default SvgPassSymb;